'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('UserInspirationsCtrl', UserInspirationsCtrl);

  UserInspirationsCtrl.$inject = ['inspirations', 'userAlias'];

  /* @ngInject */
  function UserInspirationsCtrl(inspirations, userAlias) {
    var vm = this;
    vm.title = 'UserInspirationsCtrl';
    // Set vm.infiniteScroll to `true` just to hide the "Load More" button.
    vm.infiniteScroll = true;
    vm.loading = false;
    vm.type = 'user';
    vm.$onInit = activate;

    ////////////////

    function activate() {
      vm.inspirations = inspirations;
      vm.userAlias = userAlias;
    }
  }
})();